import classNames from 'classnames';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import ThronVideo from '@components/utils/ThronVideo';
import '@moncler/scss/components/editorial-video-pdp/component-editorial-video-pdp.scss';
const EditorialVideoPDP = (props) => {
    const [playerStatus, setPlayerStatus] = useState(false);
    const [veil, setVeil] = useState(true);
    const [progressPercentage, setProgressPercentage] = useState(0);
    const videoRef = useRef();
    const handleClickVeil = useCallback(() => {
        setVeil(false);
        if (videoRef && videoRef.current) {
            let playButton = videoRef.current.querySelector('[data-pause]');
            playButton.click();
        }
    }, [videoRef, veil]);
    useEffect(() => {
        setProgressPercentage((playerStatus.currentTime / playerStatus.duration) * 100);
    }, [playerStatus]);
    const handleClickProgressBar = (e) => {
        let rect = e.target.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let progressBarPercentage = (x / e.target.clientWidth) * 100;
        let timeToSet = (progressBarPercentage / 100) * playerStatus.duration;
        videoRef.current.querySelector('.th-video-element video').currentTime = timeToSet;
        setProgressPercentage(progressBarPercentage);
    };
    if (!props.thronid) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "video-module simplified video-module-PDP no-padding" },
        veil && (React.createElement("div", { className: "video-module_veil" },
            React.createElement("button", { className: "play-button-big", "aria-label": "Play video", onClick: () => handleClickVeil() }))),
        React.createElement("div", { ref: videoRef, className: classNames('video-module__inner-container', 'video-container', 'video-opened') },
            props.thronid && (React.createElement(ThronVideo, { thronID: props.thronid, thronMobileID: props.thronmobileid, autoplay: false, lockBitrate: window.lockBitrateProductVideos, onTimeUpdate: (playerInstance) => setPlayerStatus(playerInstance.status()) })),
            !veil && React.createElement("div", { className: "pause-veil", onClick: () => handleClickVeil() }),
            React.createElement("div", { className: classNames('video-module__controls', { hidden: veil }) },
                React.createElement("button", { "data-pause": true, "aria-pressed": "true", "aria-label": "play-pause", type: "button", className: classNames('play-pause-button') }),
                React.createElement("button", { "data-mute": true, "aria-pressed": "false", "aria-label": "volume", type: "button", className: classNames('volume-button') }),
                React.createElement("div", { className: "progress-bar-wrapper", onClick: (e) => handleClickProgressBar(e) },
                    React.createElement("div", { className: "progress-bar" },
                        React.createElement("span", { className: "progress", style: { width: `${progressPercentage || 0}%`, transition: progressPercentage === 0 ? 'all 0s' : 'all 0.3s linear' } })))))));
};
export default EditorialVideoPDP;
